import {
  ASSIGN_PARTI_FAIL,
  ASSIGN_PARTI_REQUEST,
  ASSIGN_PARTI_RESET,
  ASSIGN_PARTI_SUCCESS,
  ALL_PARTI_LIST_FAIL,
  ALL_PARTI_LIST_REQUEST,
  ALL_PARTI_LIST_RESET,
  ALL_PARTI_LIST_SUCCESS,
  PARTI_LIST_FAIL,
  PARTI_LIST_REQUEST,
  PARTI_LIST_RESET,
  PARTI_LIST_RELOAD_TARGET_PARTICIPANT,
  PARTI_LIST_SUCCESS,
  DOWNLOAD_TEXT_RESP_FAIL,
  DOWNLOAD_TEXT_RESP_REQUEST,
  DOWNLOAD_TEXT_RESP_RESET,
  DOWNLOAD_TEXT_RESP_SUCCESS,
  DOWNLOAD_RESP_TIME_REQUEST,
  DOWNLOAD_RESP_TIME_SUCCESS,
  DOWNLOAD_RESP_TIME_FAIL,
  DOWNLOAD_RESP_TIME_RESET,
  CREATE_PARTI_REQUEST,
  CREATE_PARTI_SUCCESS,
  CREATE_PARTI_FAIL,
  CREATE_PARTI_RESET,
} from '../constants/participantConstants'

// participantsData => { participants:[...], study:{...} }
export const allPartiListReducer = (
  state = { participantsData: {} },
  action
) => {
  switch (action.type) {
    case ALL_PARTI_LIST_REQUEST:
      return { loading: true, participantsData: {} }
    case ALL_PARTI_LIST_SUCCESS:
      return {
        loading: false,
        participantsData: action.payload,
        success: true,
      }
    case ALL_PARTI_LIST_FAIL:
      return { loading: false, error: action.payload }
    case ALL_PARTI_LIST_RESET:
      return { participantsData: {} }
    default:
      return state
  }
}

// participantsData => { participants:[...], study:{...} }
export const partiListReducer = (state = { participantsData: {} }, action) => {
  switch (action.type) {
    case PARTI_LIST_REQUEST:
      return {
        loading: true,
        participantsData: {},
        reloadTargetParticipantIfSpecified: false,
      }
    case PARTI_LIST_SUCCESS:
      return {
        loading: false,
        participantsData: action.payload,
        //pages: action.payload.pages,
        //page: action.payload.page,
        success: true,
        reloadTargetParticipantIfSpecified: false,
      }
    case PARTI_LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
        reloadTargetParticipantIfSpecified: false,
      }
    case PARTI_LIST_RESET:
      return { participantsData: {}, reloadTargetParticipantIfSpecified: false }
    case PARTI_LIST_RELOAD_TARGET_PARTICIPANT:
      return {
        ...state,
        loading: false,
        success: false,
        reloadTargetParticipantIfSpecified: true,
      }
    default:
      return state
  }
}

export const assignPartiReducer = (state = {}, action) => {
  switch (action.type) {
    case ASSIGN_PARTI_REQUEST:
      return { loading: true }
    case ASSIGN_PARTI_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload.message,
        participantId: action.payload.participantId,
      }
    case ASSIGN_PARTI_FAIL:
      return { loading: false, success: false, error: action.payload }
    case ASSIGN_PARTI_RESET:
      return {}
    default:
      return state
  }
}

export const downloadTextRespReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_TEXT_RESP_REQUEST:
      return { loading: true }
    case DOWNLOAD_TEXT_RESP_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case DOWNLOAD_TEXT_RESP_FAIL:
      return { loading: false, success: false, error: action.payload }
    case DOWNLOAD_TEXT_RESP_RESET:
      return {}
    default:
      return state
  }
}

export const downloadRespTimeReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_RESP_TIME_REQUEST:
      return { loading: true }
    case DOWNLOAD_RESP_TIME_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case DOWNLOAD_RESP_TIME_FAIL:
      return { loading: false, success: false, error: action.payload }
    case DOWNLOAD_RESP_TIME_RESET:
      return {}
    default:
      return state
  }
}

export const createPartiReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PARTI_REQUEST:
      return { loading: true }
    case CREATE_PARTI_SUCCESS:
      return { loading: false, success: true, message: action.payload.message }
    case CREATE_PARTI_FAIL:
      return { loading: false, success: false, error: action.payload }
    case CREATE_PARTI_RESET:
      return {}
    default:
      return state
  }
}
